import { render, staticRenderFns } from "./CompleteArticle.vue?vue&type=template&id=e8f3809a&scoped=true&"
import script from "./CompleteArticle.vue?vue&type=script&lang=js&"
export * from "./CompleteArticle.vue?vue&type=script&lang=js&"
import style0 from "./CompleteArticle.vue?vue&type=style&index=0&id=e8f3809a&prod&scoped=true&lang=css&"
import style1 from "./CompleteArticle.vue?vue&type=style&index=1&id=e8f3809a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f3809a",
  null
  
)

export default component.exports